import { api } from "constants/RotasAPI";
import usePut from "hooks/usePut";
import { ConfigAssinanteDocumentoDTO } from "types/dto/groupsign/ConfigAssinanteDocumentoDTO";

export const usePutAtualizarConfigAssinanteDocumento = () => {
  return usePut<ConfigAssinanteDocumentoDTO>({
    url: `${api.groupsign.configuracaoAssinanteDocumento}`,
  });
};
